import { AppBar, Button, Modal, Toolbar, Typography } from "@mui/material";
import React from "react";
import { ArmyViewerForward } from "./ArmyViewer";
import { PointsContext } from "../contexts/pointsContext";
import { useMediaQuery, useTheme } from "@mui/material";

const StickyBottomBar = () => {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const { currentPoints } = React.useContext(PointsContext);

  const theme = useTheme();
  const isScreenSizeLarge = useMediaQuery(theme.breakpoints.up("sm"));

  return (
    <>
      <div style={{ marginTop: "58px" }} />
      <AppBar position={"fixed"} sx={{ bottom: 0, top: "auto" }}>
        <Toolbar sx={{ display: "flex", justifyContent: "space-between" }}>
          <Typography color="inherit" noWrap>
            Points Restants: {currentPoints}
          </Typography>
          {
            !isScreenSizeLarge && <Button onClick={handleOpen}>Regardée l'armée</Button>
          }
        </Toolbar>
      </AppBar>
      <Modal
        sx={{ overflow: "scroll", marginTop: "16px" }}
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <ArmyViewerForward setOpen={setOpen} />
      </Modal>
    </>
  );
};

export { StickyBottomBar };
